import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  height: "24px",
  width: "24px",
  id: "bar-graph",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32.512 25.739",
  style: {"fill":"currentColor"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      id: "Tracé_80",
      "data-name": "Tracé 80",
      d: "M2.709,63.03V40H0V64.384a1.355,1.355,0,0,0,1.355,1.355H32.512V63.03Z",
      transform: "translate(0 -40)"
    }, null, -1),
    _createElementVNode("path", {
      id: "Tracé_81",
      "data-name": "Tracé 81",
      d: "M38.773,105.355A1.355,1.355,0,0,0,37.419,104H33.355A1.355,1.355,0,0,0,32,105.355v9.483h6.773Z",
      transform: "translate(-26.581 -93.163)"
    }, null, -1),
    _createElementVNode("path", {
      id: "Tracé_82",
      "data-name": "Tracé 82",
      d: "M94.773,73.355A1.355,1.355,0,0,0,93.419,72H89.355A1.355,1.355,0,0,0,88,73.355v14.9h6.773Z",
      transform: "translate(-73.098 -66.581)"
    }, null, -1),
    _createElementVNode("path", {
      id: "Tracé_83",
      "data-name": "Tracé 83",
      d: "M150.773,41.355A1.355,1.355,0,0,0,149.419,40h-4.064A1.355,1.355,0,0,0,144,41.355v20.32h6.773Z",
      transform: "translate(-119.616 -40)"
    }, null, -1)
  ])))
}